import 'react-app-polyfill/ie9';
import isBrowserSupported from './browserCheck';
import './raven';

if (isBrowserSupported) {
  import('./reactApp');
}
